import React from 'react';
import { getAccessToken, isTokenExpired } from '../../utils/auth';

interface PrivateRouteProps {
  children: React.ReactElement;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const token = getAccessToken();
  
  // Remove console logs to prevent spam
  
  // Platform routes require platform authentication
  // Check both token existence and validity
  if (!token) {
    // Use window.location for hard redirect to ensure all state is cleared
    window.location.replace('/');
    return null;
  }
  
  if (isTokenExpired(token)) {
    // Clear expired token and redirect
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    window.location.replace('/');
    return null;
  }

  return children;
};

export default PrivateRoute;